export const SVG_PATHS = `<path d="M382 9168 c2 -7 107 -115 234 -240 l230 -228 1037 0 1036 0 186 -187 185 -186 0 -58 c0 -52 3 -60 31 -83 35 -30 69 -41 102 -32 37 10 77 49 91 91 12 34 12 44 -1 70 -9 16 -26 41 -39 54 -21 21 -30 23 -86 18 l-63 -5 -185 190 -185 190 -1030 -1 c-566 -1 -1035 2 -1042 7 -25 16 -403 394 -403 403 0 5 -23 9 -51 9 -35 0 -49 -4 -47 -12z m3064 -863 c14 -21 15 -31 6 -51 -14 -30 -33 -38 -67 -30 -62 16 -49 106 15 106 21 0 35 -8 46 -25z"></path>
        <path d="M4309 9153 c-1 -16 -2 -336 -3 -713 l-1 -685 -408 -405 c-353 -350 -411 -405 -435 -403 -37 4 -84 -37 -84 -72 0 -18 9 -35 28 -51 30 -24 64 -32 64 -14 0 6 7 10 15 10 18 0 38 45 30 69 -3 11 119 140 413 434 l418 418 3 684 c1 376 -1 700 -5 720 -8 42 -33 48 -35 8z m-840 -2262 c7 -13 6 -24 -3 -37 -14 -18 -15 -18 -35 0 -20 18 -20 20 -5 38 21 23 31 23 43 -1z"></path>
        <path
          d="M4700 8633 l0 -548 195 -195 195 -195 0 -244 1 -243 -32 -27 c-28
    -23 -32 -34 -32 -72 0 -100 93 -159 173 -110 32 19 70 78 70 107 0 30 -41 84
    -77 103 l-36 18 2 243 2 243 -200 202 -201 201 0 532 0 532 -30 0 -30 0 0
    -547z m482 -1490 c24 -21 23 -54 -2 -81 -25 -26 -33 -27 -65 -6 -27 17 -32 51
    -15 85 13 24 57 25 82 2z"
        />
        <path
          d="M4900 8636 l0 -543 153 -155 c83 -85 196 -200 250 -255 l97 -101 0
    -234 c0 -227 -1 -235 -22 -259 -12 -13 -62 -65 -111 -116 l-90 -92 2 -153 2
    -153 -174 -172 -173 -171 -347 -1 c-288 0 -349 2 -353 14 -3 8 -17 21 -30 30
    -23 15 -27 15 -59 -5 -46 -28 -52 -73 -15 -110 28 -28 68 -26 95 6 l22 26 355
    -1 355 -2 179 178 179 178 3 165 3 165 115 117 114 116 0 237 c0 206 -2 239
    -17 262 -10 14 -124 133 -255 263 l-238 238 0 536 c0 529 0 536 -20 536 -20 0
    -20 -7 -20 -544z m-802 -2408 c6 -8 6 -22 1 -36 -7 -19 -12 -21 -28 -12 -31
    16 -36 32 -16 47 23 16 30 16 43 1z"
        />
        <path
          d="M5033 8708 l0 -473 281 -280 c154 -154 289 -291 298 -305 16 -23 18
    -68 18 -536 l0 -510 -414 -412 -413 -411 -34 11 c-64 19 -149 -42 -149 -106 0
    -73 50 -121 128 -121 48 0 57 3 84 34 28 31 30 39 25 87 l-5 52 166 165 c92
    91 281 278 420 416 l252 250 0 553 0 553 -295 295 -295 296 0 457 0 457 -33 0
    -34 0 0 -472z m-255 -2984 c12 -8 22 -26 22 -40 0 -27 -32 -64 -55 -64 -22 0
    -55 37 -55 60 0 22 33 60 53 60 7 0 23 -7 35 -16z"
        />
        <path
          d="M5210 8755 c0 -359 2 -429 15 -448 8 -13 143 -151 300 -307 l285
    -285 0 -335 0 -335 150 -149 c130 -129 150 -153 150 -181 0 -77 101 -104 130
    -34 23 55 -18 110 -70 94 -16 -5 -50 23 -170 142 l-150 149 0 336 0 336 -302
    303 -301 304 2 418 c2 414 2 417 -19 417 -20 0 -20 -3 -20 -425z m988 -2039
    c6 -27 -12 -40 -37 -27 -23 13 -28 37 -8 44 22 10 42 2 45 -17z"
        />
        <path
          d="M5440 8787 l0 -392 344 -344 c334 -333 344 -344 349 -387 6 -53 5
    -52 45 -60 26 -5 36 -1 62 24 16 17 30 37 30 46 0 25 -41 56 -75 56 -27 0 -71
    41 -373 343 l-343 344 3 144 c1 79 2 251 0 382 -2 230 -3 237 -22 237 -20 0
    -20 -7 -20 -393z m775 -1117 c0 -16 -6 -26 -18 -28 -19 -4 -32 20 -23 44 9 25
    41 13 41 -16z"
        />
        <path
          d="M5770 8786 l0 -394 64 -64 c35 -34 77 -75 94 -90 29 -25 30 -29 25
    -87 -5 -58 -5 -61 27 -89 57 -53 122 -51 171 6 28 31 31 40 27 84 -8 78 -68
    127 -134 109 -44 -12 -47 -10 -137 85 l-69 72 2 381 1 381 -36 0 -35 0 0 -394z
    m344 -619 c7 -11 7 -25 0 -44 -8 -23 -16 -29 -47 -31 -31 -3 -39 1 -48 22 -15
    33 -5 70 23 83 25 12 53 0 72 -30z"
        />
        <path
          d="M6290 8726 c0 -435 -1 -454 -20 -478 -27 -35 -18 -89 18 -106 20 -9
    33 -9 58 0 53 19 55 71 7 115 l-25 22 2 450 c1 447 1 451 -20 451 -20 0 -20
    -4 -20 -454z m50 -501 c18 -21 5 -45 -25 -45 -27 0 -35 26 -13 48 16 16 23 15
    38 -3z"
        />
        <path
          d="M6490 8548 l2 -631 -21 -12 c-23 -12 -61 -75 -61 -100 0 -27 50 -95
    78 -106 43 -17 101 -4 135 29 25 25 29 37 29 82 -1 57 -26 96 -66 102 l-21 3
    -3 633 -2 632 -35 0 -36 0 1 -632z m78 -694 c15 -11 22 -25 22 -50 0 -28 -5
    -36 -27 -45 -37 -14 -70 2 -79 37 -6 22 -2 32 20 51 32 27 35 28 64 7z"
        />
        <path
          d="M6739 8583 c0 -329 0 -671 1 -760 1 -144 -1 -163 -17 -180 -45 -44
    -46 -50 -23 -88 21 -34 34 -40 74 -36 28 2 56 35 56 65 0 14 -12 36 -30 52
    l-29 28 4 758 c3 740 3 758 -16 758 -18 0 -19 -17 -20 -597z m56 -983 c5 -9
    -23 -50 -35 -50 -18 0 -32 40 -20 55 10 13 46 10 55 -5z"
        />
        <path
          d="M7270 9169 c0 -5 -66 -75 -146 -155 -128 -125 -151 -144 -179 -144
    -34 0 -58 -20 -69 -57 -9 -28 5 -55 39 -77 26 -17 27 -17 61 9 27 21 34 33 34
    61 0 31 15 49 160 194 88 88 160 165 160 170 0 6 -13 10 -30 10 -16 0 -30 -5
    -30 -11z m-302 -351 c18 -18 15 -28 -10 -37 -29 -11 -48 3 -41 29 6 22 33 26
    51 8z"
        />
        <path
          d="M0 8719 l0 -47 245 -246 246 -246 626 0 627 1 201 -201 201 -200 460
    0 c340 1 460 -2 463 -11 2 -6 16 -26 31 -43 25 -27 35 -31 79 -31 41 0 55 5
    80 29 28 26 31 36 31 87 0 51 -3 60 -30 83 -59 49 -132 41 -177 -20 l-19 -26
    -449 1 -448 2 -199 200 -200 200 -626 -1 -627 0 -257 257 -258 258 0 -46z
    m3208 -865 c47 -32 8 -117 -46 -100 -45 15 -47 80 -4 105 23 14 24 14 50 -5z"
        />
        <path
          d="M0 8437 c0 -16 201 -223 755 -777 415 -415 755 -759 755 -763 0 -5
    -245 -253 -545 -551 l-545 -541 0 -218 0 -218 -190 -191 c-105 -105 -190 -195
    -190 -199 0 -5 -9 -9 -20 -9 -23 0 -25 -12 -8 -40 9 -15 9 -24 -1 -43 -22 -40
    -9 -54 22 -23 20 20 26 33 21 52 -6 22 18 49 205 234 l211 209 0 216 0 216
    545 542 c357 354 545 548 545 561 0 13 -265 284 -776 793 -427 425 -778 773
    -780 773 -2 0 -4 -10 -4 -23z"
        />
        <path
          d="M0 8243 c0 -23 59 -86 340 -368 l340 -340 0 -277 0 -277 105 -104
    c91 -91 105 -109 105 -138 0 -36 42 -89 69 -89 38 1 75 55 65 94 -7 31 -44 56
    -80 56 -21 0 -50 23 -127 101 l-99 101 1 278 1 279 -356 355 c-196 196 -358
    356 -360 356 -2 0 -4 -12 -4 -27z m983 -1502 c7 -29 -16 -45 -43 -31 l-22 12
    23 24 c24 26 34 25 42 -5z"
        />
        <path
          d="M4038 8063 c-23 -14 -28 -25 -28 -57 0 -38 -8 -47 -267 -305 l-267
    -266 -285 -1 c-158 -1 -412 -2 -566 -3 l-280 -1 -602 -603 c-332 -331 -610
    -611 -618 -622 -12 -17 -15 -80 -15 -405 0 -212 0 -391 0 -398 0 -8 -250 -263
    -555 -569 -449 -449 -555 -560 -555 -581 0 -30 -44 -72 673 643 251 251 464
    466 472 478 12 18 14 91 14 416 l1 393 605 605 605 605 561 -1 561 0 274 275
    c249 249 277 274 308 274 41 0 69 29 69 71 0 55 -56 83 -105 52z m62 -57 c0
    -14 -4 -27 -9 -30 -22 -14 -59 23 -45 45 3 5 16 9 30 9 19 0 24 -5 24 -24z"
        />
        <path
          d="M0 7535 c0 -41 5 -48 80 -126 l80 -83 0 -365 0 -366 121 -120 121
    -119 -12 -36 c-16 -51 14 -106 72 -132 41 -18 44 -18 83 -1 59 26 74 49 75
    111 0 48 -4 57 -32 83 -28 27 -37 30 -90 28 l-59 -2 -105 104 -104 104 0 365
    -1 365 -114 117 -115 117 0 -44z m548 -1197 c18 -18 14 -63 -7 -82 -26 -23
    -60 -17 -84 15 -18 25 -18 28 -2 53 19 28 71 36 93 14z"
        />
        <path
          d="M6036 7475 c-21 -21 -26 -33 -21 -53 10 -41 44 -65 84 -58 44 7 46 9
    46 66 0 57 -2 59 -47 66 -29 5 -40 1 -62 -21z m72 -39 c5 -25 -12 -39 -37 -31
    -24 7 -27 25 -9 43 17 17 42 11 46 -12z"
        />
        <path
          d="M4335 7281 c-45 -19 -60 -50 -58 -116 l1 -62 -282 -282 -282 -281
    -1015 0 -1015 0 -217 -218 -217 -219 1 -379 1 -380 -626 -626 -626 -627 0 -44
    0 -44 660 657 660 658 0 380 0 379 196 197 196 196 1012 0 1012 0 299 301 300
    301 32 -11 c46 -17 100 11 131 67 21 38 23 46 11 74 -23 56 -54 81 -107 84
    -26 2 -56 0 -67 -5z m81 -59 c38 -25 33 -86 -8 -101 -48 -18 -87 25 -68 74 12
    31 50 45 76 27z"
        />
        <path
          d="M2307 7009 c-34 -28 -37 -34 -37 -82 1 -55 14 -78 62 -110 15 -9 38
    -17 52 -17 34 0 91 35 104 65 l12 25 259 0 c251 0 260 -1 266 -20 9 -28 67
    -70 98 -70 68 0 124 68 114 140 -8 64 -48 100 -108 100 -44 0 -50 -4 -87 -45
    l-40 -45 -245 0 -245 0 -36 45 c-35 42 -41 45 -84 45 -38 0 -55 -6 -85 -31z
    m124 -51 c10 -13 18 -31 19 -40 0 -17 -45 -58 -64 -58 -21 1 -56 38 -56 61 0
    54 66 78 101 37z m740 -2 c16 -34 3 -74 -26 -88 -22 -10 -29 -8 -50 12 -14 13
    -25 32 -25 43 0 54 80 79 101 33z"
        />
        <path
          d="M13152 6598 c-160 -161 -300 -301 -310 -311 -18 -17 -61 -18 -836
    -17 l-818 1 -106 -103 c-59 -57 -257 -253 -442 -437 l-335 -334 3 -399 3 -398
    -292 -290 -291 -290 -572 1 -571 0 -24 38 c-14 24 -39 46 -62 56 -35 16 -41
    16 -71 2 -74 -35 -99 -84 -78 -154 17 -54 52 -77 118 -77 48 1 56 5 82 36 l28
    34 588 -3 588 -4 308 308 308 308 0 401 0 401 420 416 419 417 826 0 c476 0
    825 4 825 9 0 5 134 142 297 305 218 217 303 296 320 296 20 0 23 5 23 40 0
    37 -2 40 -28 40 -24 0 -75 -46 -320 -292z m-4652 -2558 c38 -38 18 -90 -35
    -90 -51 0 -73 53 -38 92 21 24 48 23 73 -2z"
        />
        <path
          d="M12752 5996 l-727 -726 -353 0 -354 0 -794 -792 -795 -793 -186 2
    -185 1 -150 -149 c-133 -133 -153 -149 -183 -149 -24 0 -39 -7 -54 -26 -29
    -37 -26 -58 10 -88 52 -44 109 -17 109 53 0 33 12 48 139 174 l139 137 190 0
    191 0 794 795 795 795 352 0 352 0 718 720 c395 396 724 720 729 720 14 0 14
    37 1 45 -6 4 -338 -320 -738 -719z m-3704 -2670 c2 -10 0 -22 -5 -27 -20 -20
    -62 18 -47 42 10 16 49 5 52 -15z"
        />
        <path
          d="M13195 6281 c-154 -153 -303 -303 -332 -332 -28 -30 -220 -222 -425
    -426 l-374 -373 -350 0 -349 0 -542 -540 c-467 -465 -546 -540 -571 -540 -32
    0 -62 -27 -62 -56 0 -27 46 -67 77 -67 35 1 65 39 58 76 -5 32 -60 -26 710
    746 l350 351 354 0 354 0 689 690 c379 380 696 690 704 690 9 0 14 11 14 30 0
    17 -5 30 -13 30 -6 0 -138 -125 -292 -279z m-2911 -2274 c-9 -23 -41 -21 -54
    3 -9 17 -7 22 12 29 28 11 52 -7 42 -32z"
        />
        <path
          d="M13370 6305 c-58 -58 -361 -362 -675 -675 l-570 -570 -349 0 -349 0
    -277 -275 c-211 -210 -282 -275 -301 -275 -29 0 -64 -23 -79 -51 -17 -31 22
    -89 60 -89 39 0 89 62 70 85 -11 14 26 54 259 286 l271 270 344 -2 c386 -3
    357 -8 437 77 20 22 176 177 345 346 170 169 446 445 613 613 168 168 311 305
    318 305 8 0 13 12 13 30 0 17 -5 30 -13 30 -6 0 -59 -47 -117 -105z m-2513
    -1876 c-15 -24 -29 -24 -51 0 -16 17 -15 19 6 34 20 13 25 13 40 0 14 -12 15
    -19 5 -34z"
        />
        <path
          d="M2957 6293 c-20 -5 -37 -41 -37 -79 0 -19 -173 -196 -787 -809 l-788
    -785 -281 0 -281 0 -391 -391 c-310 -310 -392 -397 -392 -417 0 -14 2 -23 5
    -21 3 2 182 181 398 397 l394 392 282 0 c212 0 286 3 296 13 7 6 364 362 793
    790 767 765 781 778 823 782 26 2 49 11 56 21 17 23 17 66 1 86 -14 18 -62 29
    -91 21z m58 -63 c0 -18 -6 -26 -23 -28 -24 -4 -38 18 -28 44 3 9 15 14 28 12
    17 -2 23 -10 23 -28z"
        />
        <path
          d="M1892 6207 c-79 -52 -81 -141 -5 -195 l28 -20 -1 -178 -2 -179 -333
    -333 c-319 -319 -335 -333 -365 -328 -54 11 -93 -4 -120 -43 -37 -55 -33 -101
    15 -144 21 -19 48 -38 60 -42 31 -9 83 11 116 45 25 26 27 34 23 85 l-5 57
    339 336 338 335 0 192 0 192 40 31 c67 54 64 136 -6 184 -47 33 -78 34 -122 5z
    m98 -67 c24 -24 25 -38 4 -68 -21 -31 -67 -29 -88 3 -9 13 -16 29 -16 35 0 17
    39 50 60 50 11 0 29 -9 40 -20z m-759 -1230 c41 -22 12 -100 -37 -100 -24 0
    -64 35 -64 55 0 19 40 55 61 55 11 0 29 -5 40 -10z"
        />
        <path
          d="M3511 6129 c-41 -41 -55 -89 -30 -104 5 -4 9 -13 7 -21 -2 -8 -176
    -188 -387 -399 l-384 -385 -237 0 -237 0 -391 -390 c-215 -214 -397 -390 -404
    -390 -7 0 -144 0 -305 0 l-292 1 -425 -426 -426 -426 0 -46 0 -45 437 436 436
    436 306 0 306 0 390 391 390 390 238 -1 239 -1 398 402 398 401 34 -12 c29
    -11 39 -10 68 5 52 27 69 53 70 109 0 44 -4 53 -36 83 -29 27 -45 33 -79 33
    -37 0 -48 -6 -84 -41z m121 -36 c25 -23 22 -64 -6 -85 -30 -22 -58 -14 -79 22
    -16 26 -16 29 4 54 23 30 54 33 81 9z"
        />
        <path
          d="M12563 6080 c-25 -25 -35 -29 -54 -22 -34 13 -1210 15 -1240 3 -13
    -5 -177 -161 -363 -346 -289 -287 -342 -336 -362 -331 -30 8 -84 -37 -84 -70
    0 -27 45 -73 71 -74 25 0 62 46 61 79 0 16 8 37 18 47 10 11 162 162 338 338
    l320 318 641 3 c353 1 641 -2 641 -6 0 -17 33 -39 58 -39 65 0 96 66 52 110
    -28 28 -61 25 -97 -10z m77 -20 c14 -26 5 -40 -26 -40 -18 0 -24 5 -24 23 0
    41 31 52 50 17z m-2086 -733 c8 -13 7 -21 -6 -34 -16 -16 -19 -16 -38 2 -19
    17 -19 19 -3 37 19 21 32 20 47 -5z"
        />
        <path
          d="M12380 5940 c-10 -20 -21 -20 -541 -20 -382 0 -536 -3 -552 -12 -12
    -6 -183 -172 -380 -370 -331 -331 -361 -358 -392 -358 -46 0 -72 -36 -59 -83
    8 -28 14 -32 48 -35 48 -4 74 18 78 65 3 30 43 74 358 389 l355 354 543 0
    c457 0 542 -2 542 -14 0 -33 68 -35 98 -3 45 48 17 107 -51 107 -26 0 -39 -6
    -47 -20z m74 -25 c20 -21 9 -45 -20 -45 -29 0 -41 24 -24 45 16 19 25 19 44 0z
    m-1909 -795 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17
    -2 23 -10 23 -28z"
        />
        <path
          d="M13464 5925 c-14 -10 -48 -14 -122 -15 l-103 0 -389 -391 c-260 -261
    -395 -390 -407 -388 -49 7 -90 -32 -77 -74 25 -84 134 -71 134 16 0 29 20 52
    183 214 100 100 272 272 382 383 l199 200 91 0 c97 0 145 14 145 42 0 24 -14
    30 -36 13z m-998 -847 c8 -13 -33 -51 -47 -42 -5 3 -9 16 -9 30 0 19 5 24 24
    24 14 0 28 -5 32 -12z"
        />
        <path
          d="M4416 5904 c-21 -20 -27 -33 -23 -52 4 -23 -14 -45 -137 -169 l-142
    -143 -192 0 -192 0 -165 -167 c-401 -406 -1380 -1386 -1403 -1404 -23 -18 -43
    -19 -372 -19 l-346 0 -722 -720 c-516 -515 -722 -726 -722 -742 0 -26 -26 -49
    289 262 120 118 435 429 700 690 l483 474 346 -2 347 -3 794 795 794 796 193
    0 192 0 140 140 c122 123 143 140 172 140 33 0 80 37 80 63 0 31 -14 54 -41
    70 -39 22 -39 22 -73 -9z m74 -53 c0 -15 -29 -33 -45 -27 -18 7 -20 43 -2 49
    14 5 47 -10 47 -22z"
        />
        <path
          d="M12207 5800 c-24 -19 -40 -20 -449 -20 l-423 0 -385 -385 c-338 -339
    -388 -385 -415 -385 -67 0 -97 -58 -56 -107 41 -49 130 -7 118 56 -4 21 46 75
    376 403 l381 378 417 0 417 0 16 -25 c26 -39 62 -43 97 -9 35 34 37 57 4 89
    -29 30 -64 32 -98 5z m80 -36 c8 -20 -21 -49 -41 -41 -9 4 -16 18 -16 32 0 20
    5 25 25 25 14 0 28 -7 32 -16z m-1738 -798 c19 -23 -4 -60 -28 -46 -27 14 -33
    38 -13 49 23 14 28 13 41 -3z"
        />
        <path
          d="M13040 5240 l-435 -439 -308 -1 -309 0 -391 -390 -391 -390 -237 0
    -238 0 -393 -392 -393 -393 -61 0 c-52 0 -66 -4 -88 -25 -22 -22 -26 -33 -26
    -87 0 -56 3 -63 30 -87 65 -54 137 -41 187 35 25 37 26 43 14 76 l-13 36 383
    383 384 384 239 0 239 0 389 388 c214 213 391 389 394 391 3 3 141 4 307 3
    l302 -1 425 424 c234 234 431 425 438 425 8 0 12 17 12 50 0 34 -4 50 -12 50
    -7 -1 -209 -199 -448 -440z m-3124 -2068 c61 -41 7 -125 -62 -93 -19 8 -24 18
    -24 45 0 23 6 39 18 45 20 12 53 14 68 3z"
        />
        <path
          d="M13077 4996 l-388 -391 -282 -5 c-186 -3 -289 -9 -302 -17 -11 -6
    -32 -24 -46 -40 -15 -15 -360 -361 -768 -768 -407 -406 -741 -743 -741 -747 0
    -4 -17 -8 -37 -8 -25 -1 -48 -9 -67 -24 -25 -21 -28 -28 -22 -58 15 -82 136
    -74 136 9 0 34 37 73 784 819 l785 784 280 0 279 0 83 78 c46 42 97 93 114
    112 73 83 590 590 602 590 8 0 13 12 13 30 0 22 -4 30 -17 29 -10 -1 -192
    -177 -406 -393z m-2562 -2037 c9 -26 -12 -41 -37 -28 -21 11 -23 20 -6 37 18
    18 36 14 43 -9z"
        />
        <path
          d="M4941 5260 l-42 -40 -593 0 -593 0 -302 -305 -302 -305 3 -397 3
    -398 -419 -418 -419 -417 -821 0 -821 0 -317 -317 c-232 -231 -318 -324 -318
    -340 0 -59 42 -26 350 282 l306 305 822 0 821 0 441 438 440 438 0 400 0 400
    281 282 281 282 584 0 c528 0 584 -2 584 -16 0 -9 14 -29 31 -45 26 -24 39
    -29 83 -29 56 0 78 16 110 78 23 44 8 91 -42 132 -54 44 -97 41 -151 -10z
    m111 -37 c24 -28 26 -46 11 -75 -17 -36 -64 -39 -87 -6 -21 29 -20 40 5 72 24
    30 49 33 71 9z"
        />
        <path
          d="M3193 5227 c-27 -14 -42 -46 -36 -78 4 -21 -9 -38 -72 -99 -42 -41
    -127 -126 -188 -188 -62 -63 -265 -267 -452 -453 l-340 -339 -350 0 -349 0
    -564 -562 c-311 -310 -627 -625 -703 -702 -81 -80 -139 -146 -139 -157 0 -10
    2 -19 4 -19 6 0 200 191 882 871 l531 529 354 0 353 0 531 530 c412 412 535
    530 554 530 30 0 81 46 81 73 0 18 -55 78 -69 76 -3 -1 -16 -6 -28 -12z m57
    -66 c0 -4 -9 -16 -19 -25 -19 -17 -20 -17 -31 4 -16 29 4 54 31 39 10 -5 19
    -13 19 -18z"
        />
        <path
          d="M12820 4522 l-655 -657 -1 -387 0 -386 -200 -196 -199 -195 -1016 -1
    -1015 0 -280 -280 c-153 -154 -280 -285 -282 -290 -2 -6 -31 -10 -65 -10 -49
    -1 -67 -5 -88 -23 -63 -53 -56 -149 13 -193 56 -35 89 -31 139 16 42 39 42 40
    35 95 l-6 55 279 280 280 281 1009 -1 1010 0 38 33 c22 19 123 117 227 218
    l187 185 0 384 0 385 625 628 c344 345 630 627 635 627 6 0 10 20 10 45 0 30
    -4 45 -12 44 -7 0 -308 -296 -668 -657z m-3680 -2481 c14 -28 12 -52 -7 -73
    -45 -50 -116 11 -83 73 7 13 21 19 45 19 24 0 38 -6 45 -19z"
        />
        <path
          d="M12914 4387 c-309 -310 -567 -573 -573 -585 -8 -15 -12 -70 -11 -155
    1 -72 1 -248 1 -390 l-1 -258 -602 -602 -603 -602 -571 -3 -571 -2 -267 -272
    c-237 -241 -271 -271 -298 -271 -69 0 -105 -81 -56 -127 47 -44 108 -10 108
    60 0 22 4 40 8 40 5 0 47 39 93 87 46 47 164 166 262 265 l177 178 563 0 562
    0 623 622 622 622 0 402 0 401 550 551 c303 304 555 552 560 552 6 0 10 11 10
    25 0 14 -6 25 -12 25 -7 0 -265 -253 -574 -563z m-3484 -3197 c12 -7 12 -13 4
    -27 -23 -38 -66 -19 -50 22 6 17 24 19 46 5z"
        />
        <path
          d="M2594 4775 c-9 -14 -13 -32 -9 -45 6 -18 -37 -65 -266 -293 l-272
    -272 -346 3 -346 2 -678 -674 c-572 -569 -677 -678 -677 -702 0 -25 8 -20 99
    72 54 54 362 361 684 682 l585 582 353 0 354 0 270 270 c232 232 274 270 300
    270 33 0 75 37 75 64 0 9 -7 28 -16 41 -23 35 -87 35 -110 0z m94 -37 c2 -9
    -6 -22 -19 -28 -17 -10 -24 -9 -37 3 -8 9 -12 23 -8 32 8 22 60 16 64 -7z"
        />
        <path
          d="M12206 4393 c-37 -37 -38 -40 -33 -93 l6 -54 -340 -340 -341 -340 3
    -190 c3 -152 1 -190 -10 -194 -7 -2 -28 -17 -45 -32 -27 -25 -31 -34 -30 -81
    0 -45 5 -56 32 -81 27 -23 41 -28 85 -28 57 1 81 15 111 66 25 42 15 79 -35
    126 l-39 37 0 177 0 178 334 333 c321 321 335 333 359 322 34 -15 64 -6 110
    31 33 29 37 36 37 80 0 43 -5 54 -35 85 -31 30 -42 35 -84 35 -42 0 -52 -5
    -85 -37z m128 -48 c9 -13 16 -30 16 -37 0 -17 -41 -58 -59 -58 -22 0 -61 40
    -61 63 0 54 74 77 104 32z m-766 -1231 c36 -25 27 -79 -16 -95 -55 -21 -96 48
    -55 93 20 22 42 23 71 2z"
        />
        <path
          d="M13448 4319 c-10 -10 -18 -33 -18 -50 0 -27 -27 -58 -210 -241 l-210
    -209 0 -216 0 -215 -67 -70 c-38 -39 -283 -285 -545 -546 -263 -262 -478 -483
    -478 -492 0 -8 199 -215 443 -458 243 -243 593 -593 777 -777 184 -184 340
    -335 347 -335 8 0 13 12 13 30 0 17 -5 30 -12 30 -10 0 -1518 1503 -1518 1513
    0 2 46 50 103 106 56 56 299 298 540 539 l437 436 0 216 0 215 201 202 c111
    113 211 206 225 209 29 8 32 39 4 47 -11 3 -20 10 -20 17 0 7 9 14 20 17 26 7
    28 53 3 52 -10 0 -26 -9 -35 -20z"
        />
        <path
          d="M2925 4288 c-28 -16 -35 -28 -35 -64 0 -26 -17 -47 -106 -135 -58
    -57 -227 -225 -375 -373 l-270 -269 -425 0 c-356 0 -427 3 -437 15 -32 38 -45
    41 -82 18 -29 -18 -35 -27 -35 -57 0 -24 7 -41 22 -54 33 -27 60 -23 93 11
    l29 31 429 -2 c236 0 430 1 432 3 43 38 694 693 713 716 20 25 33 32 61 32 47
    1 81 29 81 68 0 47 -55 82 -95 60z m60 -48 c10 -16 -15 -51 -33 -48 -10 2 -18
    15 -20 31 -3 23 0 27 22 27 14 0 28 -4 31 -10z m-1737 -802 c6 -8 6 -22 1 -36
    -7 -19 -12 -21 -28 -13 -27 15 -33 39 -13 50 22 14 28 13 40 -1z"
        />
        <path
          d="M1007 4160 c-21 -16 -27 -30 -27 -58 0 -35 -18 -55 -384 -419 l-384
    -382 -104 -3 -103 -3 -3 -28 c-3 -26 -2 -27 17 -18 11 6 62 11 115 11 l95 0
    391 390 c358 357 394 390 425 390 25 0 40 8 59 31 30 36 32 46 8 76 -26 34
    -71 39 -105 13z m65 -68 c-14 -21 -16 -22 -33 -6 -23 21 -24 33 -2 49 13 10
    19 9 33 -4 14 -14 15 -19 2 -39z"
        />
        <path
          d="M2928 4107 c-20 -17 -28 -32 -28 -56 0 -30 -29 -62 -337 -367 -186
    -184 -350 -346 -365 -360 l-26 -26 -518 -3 -518 -2 -27 28 c-34 36 -77 38
    -107 6 -28 -30 -28 -58 1 -85 29 -28 78 -29 102 -2 18 20 31 20 555 20 l537 0
    371 370 c323 322 374 370 395 365 32 -8 70 23 70 59 0 30 -38 76 -62 76 -9 -1
    -28 -11 -43 -23z m65 -36 c7 -29 -16 -45 -42 -31 -27 14 -26 25 1 44 24 17 33
    14 41 -13z m-1907 -800 c-9 -14 -53 -14 -61 0 -4 5 1 19 11 30 18 19 18 19 37
    0 11 -10 16 -24 13 -30z"
        />
        <path
          d="M2923 3920 c-13 -5 -24 -17 -25 -27 0 -10 -2 -23 -2 -29 -3 -28 -50
    -79 -361 -387 l-331 -328 -620 0 c-340 0 -626 0 -635 0 -9 1 -21 12 -27 26 -9
    20 -19 25 -47 25 -19 0 -44 -8 -55 -17 -24 -21 -27 -75 -5 -93 22 -18 97 -14
    108 5 7 13 91 15 656 15 l648 0 345 345 c321 321 348 345 380 345 66 0 92 69
    42 109 -29 23 -38 24 -71 11z m62 -40 c3 -6 3 -19 0 -31 -10 -31 -49 -21 -53
    14 -3 23 0 27 22 27 14 0 28 -5 31 -10z m-2095 -730 c14 -26 5 -40 -25 -40
    -13 0 -27 4 -30 10 -9 14 13 50 30 50 8 0 19 -9 25 -20z"
        />
        <path
          d="M8660 3590 c-33 -27 -35 -32 -35 -92 l0 -63 -253 -250 c-140 -137
    -328 -323 -418 -413 l-164 -163 0 -552 0 -553 295 -293 295 -294 0 -459 0
    -458 35 0 35 0 0 471 0 470 -300 300 -300 300 0 517 0 517 412 406 412 407 56
    -5 c54 -5 57 -4 88 31 55 63 55 115 -3 173 -45 45 -103 46 -155 3z m122 -61
    c16 -22 17 -29 7 -52 -14 -30 -53 -45 -78 -30 -9 6 -20 22 -25 36 -8 22 -6 31
    14 52 29 31 56 29 82 -6z"
        />
        <path
          d="M9370 3023 c-8 -3 -19 -12 -23 -19 -6 -11 -75 -14 -363 -14 l-356 0
    -184 -182 -185 -183 2 -159 1 -159 -101 -100 c-56 -54 -106 -107 -111 -117 -5
    -10 -12 -125 -14 -256 -5 -219 -4 -239 13 -263 11 -14 125 -132 255 -261 l236
    -234 0 -538 c0 -531 0 -538 20 -538 20 0 20 7 20 543 l-1 542 -244 248 -245
    248 0 247 0 248 105 104 105 105 0 160 0 160 174 172 175 173 340 0 339 0 31
    -31 c35 -35 62 -33 99 7 27 31 28 44 1 78 -20 25 -53 32 -89 19z m64 -42 c4
    -5 3 -17 0 -26 -10 -24 -48 -15 -52 13 -3 18 1 22 22 22 14 0 27 -4 30 -9z"
        />
        <path
          d="M12933 2993 c-12 -2 -34 -18 -48 -34 -48 -58 -27 -152 42 -188 27
    -14 70 -14 78 0 4 5 11 9 16 7 5 -2 58 -52 119 -112 l110 -108 0 -364 0 -363
    113 -115 c63 -64 119 -116 125 -116 7 0 12 18 12 45 0 25 -5 45 -10 45 -6 0
    -47 38 -92 84 l-82 85 2 360 2 360 -124 122 -124 122 16 33 c14 31 14 36 -2
    66 -32 58 -89 85 -153 71z m91 -95 c12 -33 3 -55 -28 -70 -38 -17 -78 12 -74
    55 6 59 82 70 102 15z"
        />
        <path
          d="M7258 2523 c-33 -38 -37 -56 -20 -82 25 -38 43 -50 79 -49 28 1 48
    -15 172 -140 l141 -141 0 -333 0 -333 300 -300 300 -300 0 -422 c0 -416 0
    -423 20 -423 20 0 20 7 20 431 l0 431 -297 297 -298 296 -3 340 -3 340 -150
    150 c-128 128 -149 154 -149 181 0 59 -76 98 -112 57z m66 -42 c16 -17 15 -19
    -7 -34 -21 -14 -24 -14 -34 2 -7 11 -8 23 -1 34 12 22 21 21 42 -2z"
        />
        <path
          d="M12495 2513 c-26 -7 -35 -21 -35 -56 0 -48 16 -67 58 -67 34 0 46 -9
    141 -105 l105 -105 -1 -280 -2 -280 355 -355 c196 -195 362 -355 370 -355 8 0
    14 10 14 25 0 14 -6 25 -13 25 -7 0 -164 153 -350 339 l-338 340 1 282 1 283
    -105 103 c-99 96 -106 105 -106 141 0 22 -6 44 -13 50 -16 14 -57 21 -82 15z
    m60 -43 c11 -18 -6 -50 -26 -50 -22 0 -34 22 -25 45 6 17 42 20 51 5z"
        />
        <path
          d="M10322 2369 c-89 -26 -115 -136 -49 -202 32 -32 114 -35 150 -7 16
    13 33 33 37 46 l10 24 249 0 250 0 28 -36 c38 -51 83 -69 131 -53 60 19 86 55
    86 116 0 60 -24 92 -86 112 -49 16 -75 7 -118 -40 l-36 -38 -248 -2 -248 -2
    -26 33 c-20 26 -80 64 -94 59 -2 0 -18 -5 -36 -10z m69 -69 c23 -13 26 -62 3
    -84 -34 -34 -94 -9 -94 39 0 46 46 68 91 45z m740 0 c13 -7 19 -21 19 -45 0
    -51 -53 -73 -92 -38 -52 46 9 116 73 83z"
        />
        <path
          d="M9972 2341 c-13 -17 -19 -37 -15 -50 4 -17 -22 -49 -138 -165 -79
    -79 -265 -266 -414 -415 l-269 -271 -1 -702 c-1 -387 1 -709 3 -716 6 -18 30
    -15 36 6 3 9 5 326 5 704 l-1 686 407 409 c362 363 411 408 440 409 38 1 75
    34 75 67 0 32 -40 67 -76 67 -22 0 -36 -8 -52 -29z m72 -17 c21 -8 20 -40 -1
    -48 -21 -8 -48 17 -40 38 7 17 16 19 41 10z"
        />
        <path
          d="M8293 2185 c-35 -15 -83 -79 -83 -111 0 -25 55 -104 73 -104 38 -1
    39 -10 38 -263 l-2 -246 201 -201 200 -202 0 -529 0 -529 30 0 30 0 0 547 0
    548 -195 195 -194 195 -2 240 -2 239 32 27 c30 24 33 32 33 83 1 64 -15 89
    -71 112 -41 17 -47 17 -88 -1z m72 -61 c35 -23 35 -80 0 -96 -34 -15 -72 3
    -81 38 -6 22 -2 32 20 51 32 27 30 27 61 7z"
        />
        <path
          d="M7348 1798 c-28 -35 -23 -83 11 -107 36 -26 40 -26 75 2 21 17 29 33
    29 54 0 62 -78 97 -115 51z m72 -38 c8 -15 6 -21 -10 -30 -24 -13 -40 -6 -40
    19 0 35 33 43 50 11z"
        />
        <path
          d="M6690 1654 c-61 -41 -64 -71 -14 -116 l35 -32 -1 -481 c-3 -950 -2
    -1025 15 -1025 13 0 15 91 15 759 0 758 0 758 21 785 30 38 28 75 -7 103 -35
    27 -33 27 -64 7z m48 -62 c5 -30 -26 -41 -45 -16 -12 16 -11 20 4 32 23 16 37
    11 41 -16z"
        />
        <path
          d="M7236 1549 c-31 -36 -28 -62 13 -97 17 -15 35 -21 52 -18 22 4 66
    -36 362 -332 l337 -338 0 -382 c0 -375 0 -382 20 -382 20 0 20 7 20 393 l0
    392 -345 345 c-265 264 -345 349 -341 364 6 22 -10 55 -33 73 -27 21 -58 14
    -85 -18z m73 -27 c6 -11 5 -23 -3 -34 -10 -13 -15 -14 -29 -3 -20 14 -21 27
    -5 43 16 16 26 15 37 -6z"
        />
        <path
          d="M6863 1461 c-62 -56 -56 -135 14 -186 l42 -30 0 -622 1 -623 30 0 30
    0 0 627 0 627 34 31 c58 53 60 107 5 170 -27 31 -37 35 -78 35 -37 0 -53 -6
    -78 -29z m117 -50 c23 -45 2 -101 -39 -101 -9 0 -27 10 -40 21 -17 16 -21 28
    -16 48 12 49 74 70 95 32z"
        />
        <path
          d="M10220 1455 c-30 -31 -34 -41 -33 -86 1 -43 6 -56 34 -85 27 -28 40
    -34 76 -34 45 0 103 32 103 56 0 7 5 16 12 20 7 4 212 7 457 7 l444 -2 206
    -205 206 -206 622 0 621 0 256 -255 c141 -140 260 -255 266 -255 5 0 10 20 10
    45 0 25 -4 45 -8 45 -4 0 -118 110 -252 245 l-245 246 -623 -2 -624 -2 -206
    206 -207 207 -465 2 -464 3 -6 22 c-9 36 -53 63 -102 63 -37 0 -49 -5 -78 -35z
    m133 -56 c19 -27 19 -27 -4 -58 -25 -34 -53 -39 -81 -14 -38 34 -9 107 40 101
    14 -2 34 -15 45 -29z"
        />
        <path
          d="M7344 1126 c-37 -32 -39 -37 -39 -89 0 -48 4 -60 30 -87 28 -29 34
    -31 88 -28 l58 3 85 -86 84 -86 0 -377 0 -376 35 0 35 0 0 387 0 388 -100 99
    -100 99 11 32 c16 43 -1 85 -50 125 -49 41 -87 40 -137 -4z m120 -69 c7 -11 7
    -25 0 -44 -7 -22 -16 -29 -44 -31 -60 -6 -83 59 -33 97 23 19 29 20 47 8 11
    -8 24 -21 30 -30z"
        />
        <path
          d="M7114 1024 c-31 -30 -27 -68 12 -100 l25 -21 -1 -451 c-1 -448 0
    -452 20 -452 20 0 20 5 20 452 0 386 2 454 15 468 8 9 18 30 21 47 5 26 1 37
    -19 57 -33 33 -61 33 -93 0z m71 -44 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28
    12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z"
        />
        <path
          d="M10050 1017 c-45 -11 -57 -22 -82 -70 -24 -49 -19 -74 27 -123 35
    -37 35 -37 96 -30 l61 6 192 -195 193 -195 1036 0 1036 0 204 -205 205 -205
    46 0 46 0 -237 240 -237 240 -1035 0 -1036 0 -187 185 -186 185 0 55 c1 45 -4
    59 -23 78 -34 33 -77 46 -119 34z m71 -78 c22 -22 20 -66 -4 -82 -25 -16 -71
    -3 -86 24 -13 24 -13 29 2 53 21 32 59 34 88 5z"
        />
        <path
          d="M6492 434 c-16 -11 -22 -25 -22 -55 0 -39 -6 -47 -165 -205 -91 -91
    -165 -167 -165 -170 0 -2 12 -4 27 -4 23 0 57 30 180 156 138 141 157 157 190
    160 48 4 66 27 60 77 -6 46 -3 43 -47 51 -25 4 -42 1 -58 -10z m63 -54 c0 -20
    -5 -25 -25 -25 -28 0 -41 32 -18 46 23 15 43 5 43 -21z"
        />`;
